<div class="table__container">
  <ng-container *ngIf="(elements.length > 0); else blankSlateSignatoryTable">
    <table class="table table-border round-corner">
      <thead>
        <tr>
          <th scope="col" class="text-center" [ngSwitch]="headerCheckboxState"
            (click)="onHeaderCheckboxChange()">
            <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngSwitchCase="checkboxState.Unchecked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngSwitchCase="checkboxState.Checked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','minus-square']"
              *ngSwitchCase="checkboxState.Indeterminate"></fa-icon>
          </th>
          <th scope="col" class="text-left">{{ 'name' | translate | titlecase }}</th>
          <th scope="col" class="text-left">{{ 'mail' | translate | titlecase }}</th>
          <th *ngIf="!hiddenSSNColumn" scope="col" class="text-left">{{ 'ssn' | translate | uppercase }} </th>
          <th *ngIf="!hiddenPhoneColumn" scope="col" class="text-left">{{ 'phone' | translate }} </th>
          <th scope="col" class="text-left">{{ 'envelope.signatory.signatureTypeText' | translate }} </th>
          <th scope="col" class="text-left">{{ 'envelope.signatory.subscriberTypeText' | translate }} </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let element of elements; let i = index" class="cursor" (click)="onCheckboxClick(element)">
          <td width="10%" class="text-center text-overflow-none">
            <fa-icon class="fa-lg mr-1" [icon]="['fal','square']" *ngIf="!element.checked"></fa-icon>
            <fa-icon class="fa-lg mr-1" [icon]="['fas','check-square']" *ngIf="element.checked"></fa-icon>
          </td>
          <td width="20%" class="text-truncate text-left">{{element.name}}</td>
          <td width="15%" class="text-truncate text-left">{{element.mail}}</td>
          <td width="10%" *ngIf="!hiddenSSNColumn" class="text-truncate text-left">
            {{ setMaskValue(element.ssn) }}
          </td>
          <td width="10%" *ngIf="!hiddenPhoneColumn" class="text-truncate text-left">{{element.phoneNumber | phoneObfuscate }}</td>
          <td width="15%" class="text-truncate text-left">{{element.signatureType?.value}}</td>
          <td width="20%" class="text-truncate text-left">{{element.subscriberType?.value}}</td>
        </tr>

      </tbody>
    </table>

  </ng-container>
</div>

<ng-template #blankSlateSignatoryTable>
  <cdx-blankslate [options]="blankslateOptions" (buttonClick)="onBlankSlateButtonClick($event)">
    {{ 'envelope.signatory.modalAdd.noSignatoryFounded' | translate }} </cdx-blankslate>
</ng-template>
